import { AnalyticsContextType } from "@/Contexts/AnalyticsContext";
import { getCookie } from "@/utils/CookieJar";
import { createContext } from "react";

export type CookieSettings = {
    analytics: boolean;
    advertising: boolean;
};

const initialCookieSettings = {
    analytics: true,
    advertising: false,
};

export const initialCookieContext = {
    showCookieSettingsModal: false,
    showCookieBanner:
        !getCookie("hasEverBeenSaved", false) && !window.isMobileApp,
    cookieSettings: getCookie("cookie-settings", initialCookieSettings),
    resetCookieSettingsToLastSaved: () => {},
    saveCookieSettingsAndCloseAll: (
        _: CookieSettings,
        __: AnalyticsContextType,
    ) => {},
    setShowCookieSettingsModal: (_: boolean) => {},
    setShowCookieBanner: (_: boolean) => {},
    hasEverBeenSaved: getCookie("hasEverBeenSaved", false),
    analyticsSettingToggleState: initialCookieSettings.analytics,
    advertisingSettingToggleState: initialCookieSettings.advertising,
    setAnalyticsToggleState: (_: boolean) => {},
    setAdvertisingToggleState: (_: boolean) => {},
    isGpcActive: false,
};

export const CookieManagerContext = createContext(initialCookieContext);
